/**
 * Shader code for circular ribbon with marquee text
 */

export const ribbonVertexShader = `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

export const ribbonFragmentShader = `
  uniform sampler2D uTexture;
  uniform float uTime;
  varying vec2 vUv;

  void main() {
    float circumference = 2.0 * 3.14159 * 22.5;
    float aspectRatio = circumference / 2.0;
    float scrollSpeed = 2.0;
    float scrollOffset = uTime * scrollSpeed;
    vec2 adjustedUv = vUv;
    adjustedUv.x = mod(vUv.x * (aspectRatio * 0.1) + scrollOffset, 1.0);
    adjustedUv.y = vUv.y;
    vec4 color = texture2D(uTexture, adjustedUv);
    gl_FragColor = color;
  }
`;
